// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.DeviceAssertion
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Bstr

fun DeviceAssertion.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "PJ3yQ3jTsN-SSVtrq0VbveG102BDxxXnK65SXPGtguw")
val DeviceAssertion_cborSchemaId = ByteString(60, -99, -14, 67, 120, -45, -80, -33, -110, 73, 91, 107, -85, 69, 91, -67, -31, -75, -45, 96, 67, -57, 21, -25, 43, -82, 82, 92, -15, -83, -126, -20)

fun DeviceAssertion.Companion.fromCbor(data: ByteArray): DeviceAssertion {
    return DeviceAssertion.fromDataItem(Cbor.decode(data))
}

val DeviceAssertion.Companion.cborSchemaId: ByteString
    get() = DeviceAssertion_cborSchemaId

fun DeviceAssertion.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("assertionData", Bstr(this.assertionData.toByteArray()))
    builder.put("platformAssertion", Bstr(this.platformAssertion.toByteArray()))
    return builder.end().build()
}

fun DeviceAssertion.Companion.fromDataItem(dataItem: DataItem): DeviceAssertion {
    val assertionData = ByteString(dataItem["assertionData"].asBstr)
    val platformAssertion = ByteString(dataItem["platformAssertion"].asBstr)
    return DeviceAssertion(
        assertionData = assertionData,
        platformAssertion = platformAssertion,
    )
}
